// keys should be unique.
export const LS_CACHE_KEY_FOLKS_HOME_FEED = "ls_cache_folks_home_feed";
export const LS_CACHE_KEY_GENRE_FEED = "ls_cache_genre_feed";
export const LS_CACHE_KEY_FOLKS_BANNER_DATA = "ls_cache_folks_banner_data";
export const LS_CACHE_KEY_FOLKS_CONTENT_META = "ls_cache_folks_content_meta";
